if (!window.__ecommerceEventsInit) {
  window.__ecommerceEventsInit = true;

  function currency() {
    return (window.FoxTheme && window.FoxTheme.shopCurrency) || 'USD';
  }

  // GA4/GTM convention: clear the previous ecommerce object before pushing a
  // new one, so fields from one event don't leak into the next one's reads.
  function pushEvent(eventName, ecommerce) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({ event: eventName, ecommerce: ecommerce });
  }

  // HubSpot's own tracking script (_hsq) is loaded separately in
  // theme.liquid and may not be ready/present (blocked, slow network) —
  // pushing is a no-op rather than an error in that case.
  function pushHubSpotAddedToCart(properties) {
    if (!window._hsq) return;
    window._hsq.push([
      'trackCustomBehavioralEvent',
      {
        name: 'pe46526182_shopify_added_to_cart',
        properties: properties,
      },
    ]);
  }

  // Exposed globally so other cart-aware scripts (e.g. bundle-builder.js,
  // whose own add-to-cart flow never touches this file's event listeners)
  // can push through the same clear-then-push helper instead of duplicating it.
  window.themeEcommerce = { pushEvent: pushEvent, currency: currency, pushHubSpotAddedToCart: pushHubSpotAddedToCart };

  function itemFromCartItem(item) {
    var priceCents = item.price != null ? item.price : item.final_price;
    return {
      item_id: String(item.variant_id || item.id),
      item_name: item.product_title || item.title,
      item_variant: item.variant_title || undefined,
      price: (priceCents || 0) / 100,
      quantity: item.quantity || 1,
    };
  }

  // add_to_cart — every AJAX add-to-cart flow in the theme (product page
  // form, quick add, product-bundle widget) dispatches this same event with
  // the raw /cart/add.js response, so one listener here covers all of them.
  document.addEventListener('product-ajax:added', function (event) {
    var product = event.detail && event.detail.product;
    if (!product || product.status) return;

    var rawItems = (Array.isArray(product.items) ? product.items : [product]).filter(function (item) {
      return item && (item.variant_id || item.id);
    });
    if (!rawItems.length) return;

    var items = rawItems.map(itemFromCartItem);

    var value = items.reduce(function (sum, item) {
      return sum + item.price * item.quantity;
    }, 0);

    pushEvent('add_to_cart', { currency: currency(), value: value, items: items });

    rawItems.forEach(function (item) {
      var priceCents = item.price != null ? item.price : item.final_price;
      pushHubSpotAddedToCart({
        product_name: item.product_title || item.title || null,
        sku: item.sku || null,
        price: priceCents != null ? priceCents / 100 : null,
        quantity: item.quantity || 1,
        variant: item.variant_title || null,
        image_url: item.image || null,
      });
    });
  });

  // begin_checkout — fires on click of either cart's checkout button. Reads
  // the cart snapshot rendered server-side into the page (see
  // [data-cart-items-json] in cart-drawer.liquid / main-cart.liquid) rather
  // than fetching, since a fetch kicked off here has no guarantee of
  // resolving before the click's own navigation to /checkout happens.
  document.addEventListener('click', function (event) {
    var checkoutBtn = event.target.closest('[name="checkout"]');
    if (!checkoutBtn) return;

    var dataEl = document.querySelector('[data-cart-items-json]');
    if (!dataEl) return;

    try {
      var cart = JSON.parse(dataEl.textContent);
      if (!cart.items || !cart.items.length) return;
      pushEvent('begin_checkout', { currency: cart.currency, value: cart.value, items: cart.items });
    } catch (error) {
      /* a malformed snapshot shouldn't block checkout navigation */
    }
  });
}
